module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": _vm.title
    }
  }), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("\n\n        Contact Info here\n\n\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df917ab6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Contact.vue
// module id = 400
// module chunks = 0